import React, { useState } from 'react'
import legoServeices from '../../services/lego'
import { Select } from 'antd'
import bxlutils from 'bxl-utils'

const { Option } = Select
interface ISelectProps {
  brandList?: string[]
  mode?: any
  placeholder?: string
  handleChange: (val: string[]) => void
}
const BrandSelect = (props: ISelectProps) => {
  const { brandList, mode, placeholder, handleChange } = props
  const [brands, setBrands] = useState([])
  const handleSearch = bxlutils.debounce(1000, value => {
    if (value) {
      legoServeices.searchBrands(value).then(res => {
        setBrands(res.data.brands)
      })
    } else {
      setBrands([])
    }
  })

  return (
    <Select
      value={mode ? brandList : undefined}
      showSearch
      mode={mode || 'tags'}
      optionFilterProp="children"
      placeholder={placeholder}
      defaultActiveFirstOption={false}
      showArrow={false}
      filterOption={(input, option) =>
        option && option.children
          ? option.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
          : false
      }
      onSearch={handleSearch}
      onChange={handleChange}
      notFoundContent={null}
    >
      {brands.map(item => (
        <Option value={item['id']} key={item['id']}>
          {item['name']}
        </Option>
      ))}
    </Select>
  )
}

export default BrandSelect
